// MUI
import { Grid, Stack, Typography } from "@mui/material";

// Images
import pageExpired from "@/assets/images/notFound/Expired.svg";
import DASBox from "@/Layouts/components/DASBox";

const LinkPrevious = () => {
	return (
		<Typography className="regular-description" component={"span"}>
			It looks like your link has expired and a link reset is required. Please contact your system administrator to resolve the issue.
		</Typography>
	);
};

export default function ExpiredLink() {
	return (
		<Grid
			className="bg-white bg-cover bg-cogs"
			container
			justifyContent={"center"}
			alignContent={"center"}
			py={10}
			sx={{ minHeight: "100vh" }}
		>
			<Grid item xs={5}>
				<DASBox
					title={
						<Typography className="big-title" component={"span"}>
							<Typography className="big-title" component={"div"} sx={{ lineHeight: 1.3 }}>
								Link
							</Typography>
							<Typography className="big-title" component={"div"} sx={{ lineHeight: 1.3 }}>
								Expired
							</Typography>
						</Typography>
					}
					content={<LinkPrevious />}
					textSx={{ textAlign: "center", paddingTop: "65px" }}
				>
					<Stack p={3} pb={0} pt={4}>
						<img src={pageExpired} className="img-fluid" alt="Link Expired" />
					</Stack>
				</DASBox>
			</Grid>
		</Grid>
	);
}
